import { render, staticRenderFns } from "./ToastificationIcon.vue?vue&type=template&id=4be5425e&"
import script from "./ToastificationIcon.vue?vue&type=script&lang=js&"
export * from "./ToastificationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports